import { UserPlus, Search, CalendarCheck, Wallet, TrendingUp } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Heading } from "@/components/design-system/Heading";
import { motion } from "framer-motion";

const benefits = [
  {
    icon: UserPlus,
    title: "Crea el teu perfil de porter",
    description: "Comença el teu viatge com a porter"
  },
  {
    icon: Search,
    title: "Explora partits disponibles",
    description: "Troba partits que s'ajustin al teu horari"
  },
  {
    icon: CalendarCheck,
    title: "Aplica a partits",
    description: "Postula't als partits que t'interessin"
  },
  {
    icon: Wallet,
    title: "Guanya diners jugant",
    description: "Guanya diners fent el que t'apassiona"
  },
  {
    icon: TrendingUp,
    title: "Guanya més mentre jugues",
    description: "Augmenta els teus ingressos amb més partits"
  }
];

export const GoalkeeperBenefitsCa = () => {
  return (
    <div>
      <Heading level="h2" className="text-2xl font-bold mb-6 text-center">
        Per a Porters 🧤
      </Heading>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {benefits.map((benefit, index) => (
          <motion.div
            key={benefit.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="h-full"
          >
            <Card className="p-6 h-full bg-white/60 backdrop-blur border-2 border-primary/10 hover:border-primary/20 transition-all duration-300">
              <div className="mb-4 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <benefit.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};